/**
 * Format a date string (YYYY-MM-DD or ISO) to MM-DD-YYYY display format
 */
export function formatDate(dateStr) {
  if (!dateStr) return "—";
  // Handle YYYY-MM-DD
  const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return `${match[2]}-${match[3]}-${match[1]}`;
  }
  // Fallback: try parsing as Date
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  } catch {
    return dateStr;
  }
}
